import { parse, ParsedQs } from 'qs';

/**
 * Parses a query string into an object.
 *
 * This function takes a query string as input and uses the `qs` library to parse it into an object.
 * The resulting object contains key-value pairs representing the parameters in the query string.
 *
 * @param queryString - The query string to be parsed.
 * @returns An object representing the parsed query string parameters.
 */
export const getParamsObjectFromQueryString = (queryString: string) => {
  return parse(queryString);
};

/**
 * Adds a `quantities` property to the given option parameters object.
 *
 * This function takes an object representing option parameters and adds a `quantities` property to it.
 * The `quantities` property is created by copying the existing `quantities` property from the input object.
 *
 * @param optionParams - The object representing option parameters.
 * @returns A new object with the `quantities` property added.
 */
export const optionParamsWithQuantities = (
  optionParams: ParsedQs,
): ParsedQs => {
  return {
    ...optionParams,
    quantities: Object.assign({}, optionParams.quantities),
  };
};
